import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { BranchInfosManagement } from '../components/BranchInfosManagement';
import { useNavigate } from 'react-router-dom';
import { branchSchema, TBranchSchema } from '@/schemas/branch/branch.schema';
import { useTranslation } from 'react-i18next';
import { useCreateBranch } from '@/hooks/branch.hooks';
import { Loader } from '@/components/Loading/Loader';
import { getLanguage } from '@/utils/language.utils';

export const CreateBranchPage = () => {
  const { t } = useTranslation('branch');
  const navigate = useNavigate();

  const {
    watch: watchBranch,
    control: branchControl,
    register: registerBranch,
    setValue: setBranchValue,
    setError: setBranchError,
    handleSubmit: handleSubmitBranch,
    formState: { errors: branchErrors, isSubmitting: isSubmittingBranch },
  } = useForm<TBranchSchema>({
    resolver: zodResolver(branchSchema),
  });

  const { mutate: mutateCreateBranch, isPending: isPendingCreateBranch } =
    useCreateBranch({
      t,
      handleSuccess: () => navigate('/branches'),
    });

  const onSubmitBranch = (branch: TBranchSchema) => {
    const { languageCode } = getLanguage();

    const newBranch = {
      ...branch,
      languageCode,
    };

    mutateCreateBranch(newBranch);
  };

  return (
    <>
      <PageHeader
        backToLink="/branches"
        title={t('common:branch')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem text={t('branchList')} linkTo="/branches" />
            <BreadcrumbItem text={t('common:branch')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <BranchInfosManagement<TBranchSchema>
          t={t}
          watch={watchBranch}
          control={branchControl}
          register={registerBranch}
          setValue={setBranchValue}
          setError={setBranchError}
          errors={branchErrors}
          submitDisabled={isSubmittingBranch || isPendingCreateBranch}
          onSubmit={handleSubmitBranch(onSubmitBranch)}
        />
      </div>
      {(isSubmittingBranch || isPendingCreateBranch) && <Loader />}
    </>
  );
};
